import './variables';
import './functions';
import './logic';
import { wrapperBuilder } from './build';

export const ContributionsWrapper = wrapperBuilder.build();
